import React from "react";
import {styled, Tag} from "@reside/ui";

import {getWorkflowLabel} from "../start-workflow/workflowMapping";
import {getWorkflowStyle} from "./WorkflowRibbon";

const WorkflowTag = styled(Tag)<{accentColor: string; accentBg: string}>`
  background-color: ${({accentBg}) => accentBg};
  color: ${({accentColor}) => accentColor};
  border: 1px solid transparent;
`;

export const WorkflowBadge = ({workflowType}: {workflowType?: string}) => {
  const {color, bg} = getWorkflowStyle(workflowType);
  const label = getWorkflowLabel(workflowType);
  if (!label) return null;
  return (
    <WorkflowTag accentColor={color} accentBg={bg}>
      {label}
    </WorkflowTag>
  );
};
